import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import type { PostSliderItem } from 'hb-builder/components/BuilderComponents/dynamic/Slider/SliderLayouts/PostsWrapper/mapData';
import BuilderThemeProvider, {
  CONTAINER_TYPE,
  VIEW_AS,
} from 'hb-builder/components/common/BuilderThemeProvider';
import PostCard from 'hb-react/frontoffice/apps/LiveFeed/components/TopPosts/PostCardContainer/components/PostCard';

const PostItem = (item: PostSliderItem) => (
  <BuilderThemeProvider
    containerType={CONTAINER_TYPE.CARD}
    key={item.id}
    viewAs={VIEW_AS.USER}
  >
    <StyledBox>
      <PostCard {...item} />
    </StyledBox>
  </BuilderThemeProvider>
);

export default PostItem;

const StyledBox = styled(Box).attrs(() => ({
  display: 'block',
  height: '100%',
  py: 1,
}))``;
